import { createApp } from 'vue'
import { createHead } from '@vueuse/head';
import vuetify from '@/plugins/vuetify';

import router from './router';
import store from "./store";
import * as filter from './filter';

import { onAuthStateChanged } from "firebase/auth";
import { auth } from '@/config/firebase';

import App from './App.vue';
import { isAuthorizedRouter } from './router';
import VueSocials from 'vue-socials';
import { getDocData } from './utils/firebase';
import { QuillEditor, Quill } from '@vueup/vue-quill';

import '@vueup/vue-quill/dist/vue-quill.snow.css'
import './index.css';

// Import the base font format
const Font = Quill.import('attributors/class/font')

// Register the whitelist of fonts (must be class-safe)
Font.whitelist = [
  'arial', 'courier-new', 'georgia', 'trebuchet-ms', 'impact',
  'comic-sans-ms', 'cursive', 'fantasy', 'sans-serif', 'serif'
]
Quill.register(Font, true)

const head = createHead();
const app = createApp(App);

app.use(vuetify);
app.use(router);
app.use(store);
app.use(head);
app.use(VueSocials);
app.component('QuillEditor', QuillEditor)

// Global Var 
app.config.globalProperties.$store = store;
app.config.globalProperties.$filters = filter;
app.config.globalProperties.$router = router;

app.mount('#app');

let isAuthInitialized = false;

// Handle authentication state changes and routing logic
onAuthStateChanged(auth, async (user) => {
  if (user) {
    // console.log('User is signed in:', user);
    store.state.user = user;

    const redirectData = JSON.parse(localStorage.getItem('postLoginRedirect') || '{}');
    if (redirectData.path) {
      router.replace(redirectData.path).then(() => {
        setTimeout(() => {
          window.scrollTo(0, redirectData.scrollY || 0);
          if (redirectData.targetId) {
            const btn = document.querySelector(`#${redirectData.targetId}`);
            if (btn) btn.click();
          }
        }, 300);
      });

      localStorage.removeItem('postLoginRedirect');
      return;
    }
    // If the user is on the home page and logged in, redirect to profile
    if (router.currentRoute.value?.path === '/') {
      const profileData = await getDocData('profiles', user.uid);
      router.replace(`/profile/${profileData.username}`);
    }
  } else {
    // console.log('User is signed out');
    // If the user is signed out, redirect to home page
    if (isAuthorizedRouter(router.currentRoute.value?.path)) {
      router.replace('/');
    }
  }

  isAuthInitialized = true;
});

// Add router guard to handle navigation logic
router.beforeEach((to, from, next) => {
  if (!isAuthInitialized) {
    return next();
  }

  if (isAuthorizedRouter(to.path) && !auth.currentUser) {
    next({ path: '/' });
  } else if (to.path === '/' && auth.currentUser) {
    next({ path: '/' });
  } else {
    next();
  }
});
